import * as RadixTooltip from '@radix-ui/react-tooltip';
import styled from 'styled-components';

import { get } from '../../../common/ui/get';

export const Arrow = styled(RadixTooltip.Arrow)`
    fill: ${get('colors.background.emphasis')};
`;
